export const newsArticles = [
  {
    id: 1,
    title:
      'Eastern Michigan University Team Wins Top Prize at Michigan DevFest 2025 AI Hackathon',
    source: 'EMU Today',
    date: '2025-12-19',
    excerpt:
      'A team of Eastern Michigan University students won first place at the Michigan DevFest 2025 AI Hackathon, showcasing innovative AI solutions at the annual developer conference.',
    url: 'https://today.emich.edu/story/story/13179',
    image:
      'https://today.emich.edu/imgs/story/img13179_story-20251219181026.jpg',
    category: 'Events',
    featured: true,
  },
  {
    id: 2,
    title: 'Could a Hackathon Solve the Midwest Visibility Gap?',
    source: 'StartMidwest',
    date: '2026-07-01',
    excerpt:
      "At Detroit's Hack MI, three strangers took on the challenge to close the Midwest's startup visibility gap. A look at how community hackathons are driving innovation in Michigan.",
    url: 'https://www.start-midwest.com/news/could-a-hackathon-solve-the-midwest-visibility-gap',
    image:
      'https://cdn.prod.website-files.com/6841f6e5d0ad80c9f3c61f21/6a37e6bd33f67dfb87d392e8_StartMidwest%20HackMI%20Trestle%20winning%20team.webp',
    category: 'Press',
    featured: true,
  },
  {
    id: 3,
    title:
      'The Next TCNewTech? Local Entrepreneur Wants App-Building Workshops in Traverse City',
    source: 'The Ticker',
    date: '2026-01-15',
    excerpt:
      'Kalob Hagen wants to teach you how to build an app in a single day. A look at how Michigan tech communities are expanding beyond Detroit.',
    url: 'https://www.traverseticker.com/news/the-next-tcnewtech-local-entrepreneur-wants-app-building-workshops-to-be-the-new-recurring-tech-event-in-traverse-city/',
    image: null,
    category: 'Community',
    featured: false,
  },
  {
    id: 4,
    title: 'EMU Computer Science Department News & Community Partnerships',
    source: 'Eastern Michigan University',
    date: '2026-03-01',
    excerpt:
      'Eastern Michigan University Computer Science department highlights partnerships with local tech communities including Compass Detroit and GDG Detroit.',
    url: 'https://www.emich.edu/computer-science/about/news.php',
    image: null,
    category: 'Community',
    featured: false,
  },
  {
    id: 5,
    title: 'Detroit Pride Innovation Summit 2026: Breaking the Pattern',
    source: 'Compass Detroit',
    date: '2026-06-20',
    excerpt:
      'LGBTQ+ leaders, technologists, and allies gathered at IBM HQ Detroit for the Pride Innovation Summit, featuring talks by Greg Miller and Shugmi Shumunov on building inclusive tech communities.',
    url: 'https://www.detroitpridesummit.com/',
    image: null,
    category: 'Events',
    featured: true,
  },
  {
    id: 6,
    title: 'IWD Innovation Summit 2026: Break the Pattern',
    source: 'Compass Detroit',
    date: '2026-03-28',
    excerpt:
      "International Women's Day Innovation Summit brought together 40+ speakers across 8 tracks at Little Caesars Global Resource Center, celebrating women leading in technology.",
    url: 'https://iwdsummit.com',
    image: null,
    category: 'Events',
    featured: false,
  },
  {
    id: 7,
    title: 'BHM Innovation Summit 2026: The Belonging Blueprint Continues',
    source: 'Compass Detroit',
    date: '2026-02-28',
    excerpt:
      'The Black History Month Innovation Summit continued its tradition of celebrating Black excellence in technology with keynotes, panels, and networking in Detroit.',
    url: '/events',
    image: null,
    category: 'Events',
    featured: false,
  },
  {
    id: 8,
    title: 'Compass Detroit Reaches 4,111+ Members',
    source: 'Compass Detroit',
    date: '2026-05-15',
    excerpt:
      'Compass Detroit community continues to grow with 4,111+ members, 52% Black/African American, 60% women, and partnerships with 120+ companies across Michigan.',
    url: '/community',
    image: null,
    category: 'Milestones',
    featured: false,
  },
]

export const newsCategories = [
  'All',
  'Events',
  'Press',
  'Community',
  'Milestones',
]
